"use strict";

/**
 * @module indicative-formatters
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Vanilla formatter is a plain formatter to collect validation
 * errors
 */
class JsonApiFormatter {
  constructor() {
    this.errors = [];
  }
  /**
   * Adds error to the list of existing errors
   */
  addError(error, field, rule, args) {
    let message = '';
    let validation = rule;
    if (error instanceof Error) {
      message = error.message;
      validation = 'ENGINE_EXCEPTION';
    } else {
      message = error;
    }
    this.errors.push({
      source: {
        pointer: field
      },
      title: validation,
      detail: message,
      meta: {
        args
      }
    });
  }
  /**
   * Returns an array of errors or `null` when there are no
   * errors
   */
  toJSON() {
    return this.errors.length ? {
      errors: this.errors
    } : null;
  }
}
exports.JsonApiFormatter = JsonApiFormatter;